(() => {
  'use strict';
  const host = document.querySelector('[data-bst-infinite]');
  if (!host || host.dataset.bstStarted) return;
  host.dataset.bstStarted = 'true';
  const grid = host.querySelector('.bst-grid');
  const more = host.querySelector('[data-bst-more]');
  const status = host.querySelector('[data-bst-progress]');
  if (!grid || !more || !status) return;
  let next = more.href, busy = false, failed = false, total = 0;
  const seen = new Set(), pages = new Set();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting) && !busy && !failed && next) load();
  }, {rootMargin:'0px 0px 200px 0px'}) : null;
  function update() {
    const count = grid.querySelectorAll('.bst-card').length;
    status.textContent = next ? `${count} din ${total} produse. Deruleaza pentru mai multe.` : `${count} produse afisate. Ai ajuns la finalul catalogului.`;
    more.hidden = !next;
    if (next) {more.href = next; more.textContent = 'Incarca mai multe';}
  }
  async function load() {
    if (busy || !next) return;
    busy = true; failed = false; more.setAttribute('aria-disabled','true');
    status.textContent = grid.children.length ? 'Se incarca urmatoarele produse...' : 'Se incarca cele mai noi produse...';
    const request = new URL(next, location.href);
    request.searchParams.set('sort_by','created-descending');
    request.searchParams.set('section_id','bst-catalog');
    if (request.origin !== new URL(more.href,location.href).origin || pages.has(request.href)) {
      next = null; busy = false; update(); return;
    }
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(request.href, {signal:controller.signal,headers:{Accept:'text/html'},credentials:'same-origin'});
      if (!response.ok) throw new Error('HTTP '+response.status);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html,'text/html');
      const incoming = doc.querySelector('.bst-grid');
      if (!incoming || html.includes('Liquid error')) throw new Error('Invalid catalog response');
      const fragment = document.createDocumentFragment();
      for (const card of incoming.querySelectorAll('.bst-card')) {
        const url = card.querySelector('.bst-photo')?.getAttribute('href');
        const key = card.dataset.productId || (url && new URL(url,request.href).pathname);
        if (!key || seen.has(key)) continue;
        seen.add(key); fragment.appendChild(document.importNode(card,true));
      }
      grid.appendChild(fragment);
      total = Number(incoming.dataset.total) || total || seen.size;
      pages.add(request.href);
      const nextLink = doc.querySelector('.bst-pagination a[rel="next"]');
      next = nextLink ? new URL(nextLink.getAttribute('href'),request.href).href : null;
      if (next && pages.has(next)) next = null;
      update();
      document.dispatchEvent(new CustomEvent('bst:products-loaded'));
      if (!next) observer?.disconnect();
    } catch (_) {
      failed = true;
      status.textContent = 'Nu am putut incarca produsele. Lista existenta este pastrata.';
      more.textContent = 'Reincearca incarcarea';
      more.hidden = false;
    } finally {
      clearTimeout(timer); busy = false; more.removeAttribute('aria-disabled');
    }
  }
  more.addEventListener('click', event => {event.preventDefault(); load();});
  observer?.observe(more);
  load();
})();
